import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  isExternal?: boolean;
  className?: string;
  iconClassName?: string;
  prefetch?: boolean;
  linkText?: string;
};
const ContactAdvisorLink = ({
  isExternal = true,
  className,
  iconClassName,
  prefetch,
  linkText = 'contact an advisor',
  ...props
}: Props) => {
  return (
    <Link
      href={process.env.NEXT_PUBLIC_CONTACT_ADVISER_LINK || '#'}
      target="_blank"
      prefetch={prefetch}
      className={clsx('text-spblue hover:underline focus:underline', className)}
      {...props}
    >
      {linkText}
      {isExternal ? (
        <>
          <i
            className={clsx('fal fa-external-link ml-1 inline text-xl text-spblue', iconClassName)}
          />
          <span className="sr-only">(opens in new tab)</span>
        </>
      ) : null}
    </Link>
  );
};

export default ContactAdvisorLink;
